import { FC } from 'react';
import { Icon } from '@kontentino/ui';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

type Props = {
  icon: IconDefinition;
  label: string;
  onClick: () => void;
  dataCy: string;
  tone: 'primary' | 'neutral';
  labelClassName?: string;
};

const toneToHover: Record<Props['tone'], string> = {
  primary: 'hover:tw-bg-primary-10',
  neutral: 'hover:tw-bg-grayscale-10',
};

const ProfileListFooterAction: FC<Props> = ({
  icon,
  label,
  onClick,
  dataCy,
  tone,
  labelClassName = 'tw-text-sm tw-font-medium tw-text-grayscale-180',
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`tw-flex tw-h-8 tw-w-full tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded tw-px-2 tw-py-2 tw-text-left ${toneToHover[tone]}`}
    data-cy={dataCy}
  >
    <Icon icon={icon} className="tw-text-grayscale-100" />
    <span className={labelClassName}>{label}</span>
  </button>
);

export default ProfileListFooterAction;
